// @flow
import { type LayoutControl } from '../detailed-availability/DetailedAvailabilityPageLayout'

export const shouldUseSmallerGrid = (layoutContext: LayoutControl) => {
  const { isMobileApp, windowSize } = layoutContext;
  const isSmallWindow = windowSize === 'xs' || windowSize === 'sm'
  return isSmallWindow || isMobileApp
}
